"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMenuWidget = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Menu = _interopRequireDefault(require("@material-ui/core/Menu"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _icons = require("@material-ui/icons");

var _CloseSharp = _interopRequireDefault(require("@material-ui/icons/CloseSharp"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _userUtils = require("../../../header/userUtils");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MOBILE_BEHAVIOR = {
  DRAWER: 'drawer',
  POPOVER: 'popover'
};

var UserMenuWidget = function UserMenuWidget(props) {
  var username = props.username,
      onLogin = props.onLogin,
      onClickUserAvatar = props.onClickUserAvatar,
      email = props.email,
      items = props.items,
      isUserLogged = props.isUserLogged,
      mobileOpenBehavior = props.mobileOpenBehavior,
      loginMenuLabel = props.loginMenuLabel,
      className = props.className,
      hidden = props.hidden,
      hide = props.hide,
      logginToAppicon = props.logginToAppicon;
  var initials = (0, _userUtils.getInitials)(username);

  var _useState = (0, _react.useState)({
    ref: null,
    isOpen: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var avatarRef = (0, _react.useRef)(null);
  var classes = (0, _styles.default)();

  var handleMenu = function handleMenu() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isOpen: true,
        ref: avatarRef.current
      });
    });
  };

  var handleClose = function handleClose() {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        isOpen: false,
        ref: null
      });
    });
  };

  var drawerHiddenProps = function drawerHiddenProps() {
    if (mobileOpenBehavior === MOBILE_BEHAVIOR.DRAWER) {
      return {
        smUp: true
      };
    }

    return {
      only: ['xs', 'sm', 'md', 'lg', 'xl']
    };
  };

  var popoverHiddenProps = function popoverHiddenProps() {
    if (mobileOpenBehavior === MOBILE_BEHAVIOR.DRAWER) {
      return {
        only: ['xs']
      };
    }

    return {};
  };

  if (hide) return null;
  return /*#__PURE__*/_react.default.createElement(_core.Hidden, hidden, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    ref: avatarRef,
    className: (0, _classnames.default)([classes.avatar, className]),
    onClick: handleMenu,
    edge: "end",
    "aria-label": "Perfil de Usu\xE1rio"
  }, isUserLogged ? /*#__PURE__*/_react.default.createElement(_Avatar.default, null, initials) : /*#__PURE__*/_react.default.createElement(_Avatar.default, null)), /*#__PURE__*/_react.default.createElement(_core.Hidden, drawerHiddenProps(), /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    classes: {
      paper: classes.drawerPaper
    },
    className: classes.drawer,
    variant: "temporary",
    anchor: "right",
    open: state.isOpen,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.drawerMenuHeader
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    edge: "end",
    className: classes.closeButton,
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement(_CloseSharp.default, {
    className: classes.closeIcon
  }))), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(MenuOptionsLoggedRelay, {
    email: email,
    initials: initials,
    isUserLogged: isUserLogged,
    items: items,
    loginMenuLabel: loginMenuLabel,
    onClickUserAvatar: onClickUserAvatar,
    onLogin: onLogin,
    username: username,
    logginToAppicon: logginToAppicon
  }))), /*#__PURE__*/_react.default.createElement(_core.Hidden, popoverHiddenProps(), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    className: classes.menu,
    anchorEl: state.ref,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: state.isOpen,
    onClose: handleClose
  }, /*#__PURE__*/_react.default.createElement(MenuOptionsLoggedRelay, {
    email: email,
    initials: initials,
    isUserLogged: isUserLogged,
    items: items,
    loginMenuLabel: loginMenuLabel,
    onClickUserAvatar: onClickUserAvatar,
    onLogin: onLogin,
    username: username,
    logginToAppicon: logginToAppicon
  }))));
};

exports.UserMenuWidget = UserMenuWidget;

var MenuOptionsLoggedRelay = function MenuOptionsLoggedRelay(props) {
  /* eslint-disable react/prop-types */
  var initials = props.initials,
      username = props.username,
      isUserLogged = props.isUserLogged,
      email = props.email,
      onExit = props.onExit,
      onLogin = props.onLogin,
      items = props.items,
      onClickUserAvatar = props.onClickUserAvatar,
      logginToAppicon = props.logginToAppicon;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isUserLogged ? /*#__PURE__*/_react.default.createElement(LoggedMenuItems, {
    items: items,
    initials: initials,
    username: username,
    email: email,
    onExit: onExit,
    onClickUserAvatar: onClickUserAvatar
  }) : /*#__PURE__*/_react.default.createElement(NotLoggedMenuItems, {
    icon: logginToAppicon,
    onLogin: onLogin
  }));
  /* eslint-enable react/prop-types */
};

var LoggedMenuItems = function LoggedMenuItems(props) {
  /* eslint-disable react/prop-types */
  var initials = props.initials,
      username = props.username,
      email = props.email,
      onClickUserAvatar = props.onClickUserAvatar,
      items = props.items;
  var classes = (0, _styles.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    style: {
      marginTop: 8
    },
    onClick: onClickUserAvatar
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    className: classes.menuAvatar
  }, initials), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _classnames.default)(classes.primaryText, classes.ellipsis)
  }, username, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _classnames.default)(classes.secondaryText, classes.ellipsis)
  }, email))), items.map(function (_ref) {
    var onClick = _ref.onClick,
        Icon = _ref.icon,
        label = _ref.label,
        hasDivider = _ref.hasDivider;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasDivider && /*#__PURE__*/_react.default.createElement(_Divider.default, {
      style: {
        margin: '8px 0'
      }
    }), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      onClick: onClick
    }, Icon && /*#__PURE__*/_react.default.createElement(Icon, {
      style: {
        marginRight: 24,
        marginLeft: 8
      }
    }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: classes.menuItemText
    }, label)));
  }));
  /* eslint-enable react/prop-types */
}; // eslint-disable-next-line react/prop-types


var NotLoggedMenuItems = function NotLoggedMenuItems(_ref2) {
  var icon = _ref2.icon,
      onLogin = _ref2.onLogin;
  var classes = (0, _styles.default)();

  var notLoggedIcon = icon || /*#__PURE__*/_react.default.createElement(_icons.ExitToApp, null);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
    onClick: onLogin
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "inherit",
    className: classes.logginToAppIcon
  }, notLoggedIcon), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.menuItemText
  }, "Fa\xE7a login ou cadastre-se")));
};

UserMenuWidget.propTypes = {
  /**
   * Nome do usuario logado
   */
  username: _propTypes.default.string.isRequired,

  /**
   * Email do usuario logado
   */
  email: _propTypes.default.string.isRequired,

  /**
   * Função executada ao clickar no item do menu para fazer login
   */
  onLogin: _propTypes.default.func.isRequired,

  /**
   * Lista de itens que serão exibidos no menu quando **LOGADO**
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Icone que sera exibido */
    icon: _propTypes.default.node,

    /** ação que será executada ao clicar no item do menu */
    onClick: _propTypes.default.func,

    /** texto que será exibido no item do menu */
    label: _propTypes.default.string,

    /** indica se deve colocar um divider acima do item, para criar secões */
    hasDivider: _propTypes.default.bool
  })),

  /**
   * Utilizado para mudar o estado do componente para usuario logado ou não
   */
  isUserLogged: _propTypes.default.bool.isRequired,

  /** Usado para customizar o texto da opção de login */
  loginMenuLabel: _propTypes.default.string,

  /** função executada ao clicar no Avatar **DENTRO** do menu */
  onClickUserAvatar: _propTypes.default.func,

  /**
   * Indica o comportamento do menu nas resoluções menores
   * * `drawer`- Exibirá as opções em um menu lateral surgindo da direita
   * * `popover` - Exibirá as opções em um popover
   */
  mobileOpenBehavior: _propTypes.default.oneOf([MOBILE_BEHAVIOR.DRAWER, MOBILE_BEHAVIOR.POPOVER]),
  className: _propTypes.default.string,

  /** Flag de curto-circuito para esconder o widget */
  hide: _propTypes.default.bool,

  /**
   * Propriedades para controlar quando esconder um objeto usa a mesma api do Componente do MUI Hidden
   * {@link https://v4.mui.com/components/hidden/#hidden [Detalhes]}
   */
  hidden: _propTypes.default.shape({
    lgDown: _propTypes.default.bool,
    lgUp: _propTypes.default.bool,
    mdDown: _propTypes.default.bool,
    mdUp: _propTypes.default.bool,
    only: _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])),
    smDown: _propTypes.default.bool,
    smUp: _propTypes.default.bool,
    xlDown: _propTypes.default.bool,
    xlUp: _propTypes.default.bool,
    xsDown: _propTypes.default.bool,
    xsUp: _propTypes.default.bool
  }),

  /** Icone exibido quando usuário não está logado */
  logginToAppicon: _propTypes.default.node
};
UserMenuWidget.defaultProps = {
  items: [],
  mobileOpenBehavior: MOBILE_BEHAVIOR.DRAWER,
  onClickUserAvatar: function onClickUserAvatar() {
    return null;
  },
  loginMenuLabel: 'Faça login ou cadastre-se',
  className: '',
  hide: false,
  hidden: {
    lgDown: false,
    lgUp: false,
    mdDown: false,
    mdUp: false,
    only: null,
    smDown: false,
    smUp: false,
    xlDown: false,
    xlUp: false,
    xsDown: false,
    xsUp: false
  },
  logginToAppicon: /*#__PURE__*/_react.default.createElement(_icons.ExitToApp, null)
};